// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@stoneage/XDL/types";

export default {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: [0, 481, 769, 1025, 1381],
    maxWidths: [480, 768, 1024, 1380, 1380],
    paddingValues: [16, 16, 24, 40, 40],
} as xBaseTheme["breakpoints"];
